// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"eaf744a2","237":"a986cdfa","365":"3a6b74c6","488":"29b71886","511":"8e94048a","658":"f552aa67"}[chunkId] + ".chunk.js";
};